/// <reference path="../../HTML/Tag.ts" />
/// <reference path="../../HTML/Box/Search/SearchBox.ts" />
namespace HA.Core.Controller.Page {
    import SearchBox = HA.Core.HTML.SearchBox;
    export class SearchBoxController extends Controller {
        /**
         * @param data
         */
        protected initialize(data: Map<any, any>) {
            super.initialize(data);
            this.createSearchBox();
        }

        protected createSearchBox() {
            this.addToData("tag", new SearchBox(this.getData()));
        }
    }
}
